import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { withCommentContext } from '../CommentContext';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import EyeIcon from '../../../Icons/Eye';
import UnwatchIcon from '../../../Icons/Unwatch';
import ErrorIcon from '../../../Icons/Error';
import { BiDataHook } from '../../../biLogger';
import s from '../../Comment.scss';
var CommentBody = /** @class */ (function (_super) {
    tslib_1.__extends(CommentBody, _super);
    function CommentBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onReveal = function () {
            _this.props.setPeeking(true);
        };
        return _this;
    }
    CommentBody.prototype.render = function () {
        var _a = this.props, comment = _a.comment, header = _a.header, footer = _a.footer, className = _a.className, _b = _a.comment, isSpam = _b.isSpam, isHidden = _b.isHidden, onMouseLeave = _a.onMouseLeave, isPeeking = _a.isPeeking;
        var isDeleted = comment.isDeleted, isAdminHidden = comment.isAdminHidden, isAuthor = comment.isAuthor, isOwner = comment.isOwner;
        var isVisible = !isAdminHidden && !isDeleted;
        var hasControls = (isAuthor || isOwner) && !isSpam;
        if (!isPeeking && isSpam && comment.replies !== 0) {
            return this.renderSpam();
        }
        if (!isPeeking && (isHidden || !isVisible) && comment.replies !== 0) {
            return React.createElement("div", { className: className }, this.renderHidden());
        }
        if ((isHidden || !isVisible || isSpam) && !isPeeking) {
            return null;
        }
        return (React.createElement("div", { className: classnames(className, hasControls && s['actionable']), onMouseLeave: onMouseLeave },
            header,
            this.renderBody(),
            footer));
    };
    CommentBody.prototype.renderBody = function () {
        var _a = this.props.comment, textContent = _a.textContent, commentId = _a.commentId;
        return (React.createElement("div", { className: s['comment-body-wrap'], "data-hook": BiDataHook.COMMENT_BODY },
            React.createElement(TextRenderer, { textContent: textContent, reactViewer: CommentViewer, className: classnames(s['comment'], this.props.bodyClassName), legacyTheme: 'comments', viewerKey: commentId })));
    };
    CommentBody.prototype.renderHidden = function () {
        var t = this.props.t;
        if (this.canPeek()) {
            return (React.createElement("button", { className: s['hidden-but-viewable'], onClick: this.onReveal },
                React.createElement("span", { className: s['hidden-text'] },
                    React.createElement(UnwatchIcon, { className: s['hidden-icon'] }),
                    t('comment.visibility.hidden')),
                React.createElement("span", { className: s['hidden-text-hover'] },
                    React.createElement(EyeIcon, { className: s['hidden-icon'] }),
                    t('comment.visibility.hidden.showComment'))));
        }
        return (React.createElement("button", { className: s['hidden'] },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(UnwatchIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden'))));
    };
    CommentBody.prototype.renderSpam = function () {
        var t = this.props.t;
        return (React.createElement("button", { className: s['spam'], onClick: this.canPeek() ? this.onReveal : undefined },
            React.createElement("span", { className: s['spam-text'] },
                React.createElement(ErrorIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.spam'))));
    };
    CommentBody.prototype.canPeek = function () {
        // $canPeek = ($is_admin_mode && ($is_hidden || $is_admin_hidden || $is_spam || $is_deleted)) // admin can see all
        //         || ($is_owner && (($is_hidden && !$is_admin_hidden) || $is_spam)) // owner can see owner-hidden or spam
        //         || ($is_author && $is_deleted); // author can see deleted
        var comment = this.props.comment;
        if (comment.isAdminMode) {
            return true;
        }
        if (comment.isOwner) {
            // owner can see owner-hidden
            if (comment.isHidden && !comment.isAdminHidden) {
                return true;
            }
            // and spam
            if (comment.isSpam) {
                return true;
            }
        }
        if (comment.isAuthor) {
            // comment author can see deleted
            if (comment.isDeleted) {
                return true;
            }
        }
        return false;
    };
    return CommentBody;
}(React.Component));
export default withCommentContext(withTranslation()(CommentBody));
//# sourceMappingURL=CommentBody.js.map